import { Plugin } from "prosemirror-state";
import {
  Slice,
  Fragment,
  Schema,
  NodeType,
  Node,
  Mark,
} from "prosemirror-model";

export const pastingHandler = (
  fragment: Fragment,
  regexp: RegExp,
  type: NodeType,
  getAttrs,
  schema: Schema
) => {
  const nodes: Node[] = [];

  fragment.forEach((child: Node) => {
    if (child.isText) {
      const { text } = child;
      let pos = 0;
      let match: RegExpExecArray;

      const markTypes: Mark[] = child.marks;

      // eslint-disable-next-line
      while ((match = regexp.exec(text)) !== null) {
        if (match[0]) {
          const start = match.index;
          const end = start + match[0].length;
          const attrs =
            getAttrs instanceof Function
              ? getAttrs(match[0], match[1].length)
              : getAttrs;

          // adding text before markdown to nodes
          if (start > 0) {
            nodes.push(child.cut(pos, start));
          }
          // create the node
          nodes.push(
            type.create(
              attrs,
              undefined,
              markTypes.concat([
                schema.marks["underline"].create({ color: attrs.colorLink }),
              ])
            )
          );

          pos = end;
        }
      }

      // adding rest of text to nodes
      if (pos < text.length) {
        nodes.push(child.cut(pos));
      }
    } else {
      nodes.push(
        child.copy(
          pastingHandler(child.content, regexp, type, getAttrs, schema)
        )
      );
    }
  });

  return Fragment.fromArray(nodes);
};

export function nodePasteRuleLink(
  regexp: RegExp,
  type: NodeType,
  getAttrs,
  schema: Schema
) {
  return new Plugin({
    props: {
      transformPasted: (slice) =>
        new Slice(
          pastingHandler(slice.content, regexp, type, getAttrs, schema),
          slice.openStart,
          slice.openEnd
        ),
    },
  });
}
